module.exports = __webpack_public_path__ + "static/media/fac ico@3x.3869f299.png";